/**
 * ChangedLanguage.jsx
 * Tatalli Cloud — Dil değişikliği sonrası yönlendirme
 * Login başarısı sonrası /changed-language üzerinden /dashboard'a geçiş.
 */

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ChangedLanguage() {
  const navigate   = useNavigate();
  const { t }      = useTranslation();

  useEffect(() => {
    // Kullanıcı oturumundan dil tercihini oku ve i18n'e uygula
    try {
      const raw = sessionStorage.getItem('currentSession');
      if (raw) {
        const oturum = JSON.parse(raw);
        const dil = oturum?.language?.toLowerCase();
        if (dil === 'tr' || dil === 'en') {
          localStorage.setItem('tatalli_dil', dil);
          // i18n bu noktada zaten başlatılmış olduğundan doğrudan değiştirebiliriz
          import('../i18n').then(m => m.default.changeLanguage(dil)).catch(() => {});
        }
      }
    } catch {}

    const timer = setTimeout(() => navigate('/portal/dashboard'), 300);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      height: '100vh', background: 'var(--arkaplan-govde, #f2f4f8)'
    }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
        <div className="yuklenici-cember yuklenici-cember-buyuk" />
        <span style={{ fontSize: 14, color: '#6b7280' }}>
          {t('common.loading', 'Loading...')}
        </span>
      </div>
    </div>
  );
}
